import { Injectable, OnInit, Output } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { ValetParkingMapComponent } from "../components/valet-parking-map/valet-parking-map.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
@Injectable({
  providedIn: "root",
})
export class ValetParkingService {
  
  private dialogRef: MatDialogRef<ValetParkingMapComponent> | null = null;
 
  DataGeoJson$: Subject<EstatusJSON> = new Subject<EstatusJSON>();

  existValetParking: boolean = false;
  coordsValetParking: { lat: number, lng: number } = { lat: 90, lng: 90 };
  radioKm: number = 0.01;
  bufferFeature: any;
  
  constructor(private dialog: MatDialog) {
  }

  openDialog(identifier: any): any {
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(ValetParkingMapComponent, {
        width: '600px',
        data: { identificador: identifier },
        hasBackdrop: false,
        disableClose: true,
        position: {
          bottom: '0px'
        },
        panelClass: 'custom-dialog-container'
      });

      this.dialogRef.afterClosed().subscribe((data) => {
        this.dialogRef = null;
      });

      return this.dialogRef;
    }
  }

  closeDialog() {
    console.log('valet', this.dialogRef);
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }


}
